import { render } from "./CapturedOasis.vue?vue&type=template&id=96a1ecd8"
import script from "./CapturedOasis.vue?vue&type=script&lang=js"
export * from "./CapturedOasis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/CapturedOasis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96a1ecd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96a1ecd8', __exports__)) {
    api.reload('96a1ecd8', __exports__)
  }
  
  module.hot.accept("./CapturedOasis.vue?vue&type=template&id=96a1ecd8", () => {
    api.rerender('96a1ecd8', render)
  })

}


export default __exports__